import React from 'react';
import styled from 'styled-components';
import fn from '../../helpers/fn';

const Logo = props => (
  <img
    alt="SpaceTranslate"
    {...props}
    src="/favicon-196x196.png"
  />
);

export default fn(__filename, styled(Logo)`
  display: block;
  height: 98px;
  margin: 32px auto;
  width: 98px;
`);



// WEBPACK FOOTER //
// ./src/components/icons/LogoLarge.js